import { render, staticRenderFns } from "./NomeFornecedorMenu.vue?vue&type=template&id=b6321a1e&scoped=true"
import script from "./NomeFornecedorMenu.vue?vue&type=script&lang=js"
export * from "./NomeFornecedorMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6321a1e",
  null
  
)

export default component.exports